import React from "react";
import { SplashView } from "../views/splash/SplashView";
import { View } from "react-native";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { TopNavigation } from "../components/menu/TopNavigation";
import { LeaderboardController } from "./LeaderboardController";
import { HomeController } from "./HomeController";
import BottomNavigation from "../components/menu/BottomNavigation";
import { ButtonSize, ButtonTheme, RoundedButton } from "../components/buttons/roundedButton/RoundedButton";
import { GlobalStyles } from "../components/style/Style";
import { useServices } from "../contexts/ServiceContext";
import { LOCAL_STORAGE_KEY, Screen, useApplication } from "../contexts/ApplicationContext";
import { EventController } from "./event/EventController";
import { FlexContainer } from "../components/containers/FlexContainer";
import { FreeplayMessageInjector } from "../services/FreeplayMessageInjector";
import { MyPicksController } from "./MyPicksController";
import { Loading } from "../components/animations/Loading";

export const ApplicationController = (): JSX.Element => {
    const { fpUser, login, logout } = useServices();
    const { appState } = useApplication();

    const {
        fontLoaded,
        headerVisible,
        bottomNavigationVisible,
        currentScreen,
        loginButtonVisible,
        loginButtonText,
        showLoadingAnimation,
    } = appState;

    const styles = useDynamicStyles(calculateStyles);

    const displayCurrentAppState = () => {
        switch (currentScreen) {
            case Screen.HOME:
                return <HomeController />;
            case Screen.LEADERBOARD:
                return <LeaderboardController />;
            case Screen.EVENT:
                return <EventController />;
            case Screen.MY_PICKS:
                return <MyPicksController />;
            default:
                return <>{fontLoaded && <SplashView />}</>;
        }
    };

    const handleLoginButton = async () => {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(appState));
        login();
    };

    return (
        <FlexContainer>
            <FreeplayMessageInjector />
            {showLoadingAnimation && <Loading />}
            {headerVisible && (
                <TopNavigation
                    // only logout locally + basically hard reset the app @ the tenant url
                    signOut={() => logout()}
                    signIn={() => {
                        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(appState));
                        login();
                    }}
                />
            )}
            <View style={styles.contentContainer}>{displayCurrentAppState()}</View>
            {loginButtonVisible && (
                <View style={styles.loginButton}>
                    <RoundedButton
                        config={{
                            buttonText: loginButtonText,
                            size: ButtonSize.LARGE,
                            theme: ButtonTheme.CTA,
                            width: 250,
                            height: 50,
                        }}
                        testID={`create-account-submit`}
                        onPress={handleLoginButton}
                    />
                </View>
            )}
            {bottomNavigationVisible && <BottomNavigation loggedIn={!!fpUser} />}
        </FlexContainer>
    );
};

const calculateStyles = () => {
    return EStyleSheet.create({
        outer: {
            flex: 1,
            paddingTop: 30,
        },
        container: {
            zIndex: 1,
            width: 350,
            height: 600,
            borderColor: () => EStyleSheet.value(GlobalStyles.BASE_COLOUR),
            borderWidth: () => EStyleSheet.value(GlobalStyles.BORDER_THICKNESS),
            borderRadius: 15,
            alignSelf: "center",
            overflow: "hidden",
        },
        contentContainer: {
            flex: 1,
            height: "100%",
        },
        loginButton: {
            paddingTop: 20,
            paddingHorizontal: 20,
            alignContent: "center",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            bottom: 0,
            height: 90,
            backgroundColor: () => EStyleSheet.value(GlobalStyles.BACKGROUND_COLOUR),
        },
    });
};
